import React from "react";

function inline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? <strong key={i}>{p.slice(2, -2)}</strong> : p
  );
}

export function MiniMarkdown({ content, light = false }) {
  const base = light ? "text-slate-700" : "text-slate-300";
  const head = light ? "text-slate-900" : "text-white";
  const lines = (content || "").split("\n");
  return (
    <div className={`text-sm leading-relaxed ${base}`}>
      {lines.map((ln, i) => {
        const t = ln.trim();
        if (!t) return <div key={i} className="h-2" />;
        if (t.startsWith("### ")) return <h4 key={i} className={`font-bold mt-3 mb-1 ${head}`}>{inline(t.slice(4))}</h4>;
        if (t.startsWith("## ")) return <h3 key={i} className={`font-bold text-base mt-4 mb-1 ${head}`}>{inline(t.slice(3))}</h3>;
        if (t.startsWith("# ")) return <h2 key={i} className={`font-extrabold text-lg mt-4 mb-1 ${head}`}>{inline(t.slice(2))}</h2>;
        if (/^[-*] /.test(t)) return <div key={i} className="flex gap-2 pl-2"><span className="shrink-0">•</span><span>{inline(t.slice(2))}</span></div>;
        if (/^\d+\. /.test(t)) return <div key={i} className="flex gap-2 pl-2"><span className="shrink-0 font-semibold">{t.match(/^\d+/)[0]}.</span><span>{inline(t.replace(/^\d+\. /, ""))}</span></div>;
        return <p key={i}>{inline(t)}</p>;
      })}
    </div>
  );
}
